// Experience.js
import * as THREE from "three";
import EventEmitter from "./Utils/EventEmitter.js";

import Debug from "./Utils/Debug.js";

// Core
import Camera from "./Camera.js";
import Renderer from "./Renderer.js";
import World from "./World/World.js";
import Transition from "./Transition.js";

export default class Experience extends EventEmitter {
  constructor(app) {
    super();

    this.debug = new Debug();

    this.resources = app.resources;
    this.time = app.time;
    this.sizes = app.sizes;

    this.scroll = app.scroll;

    this.initTransition();
    this.initEvents();
  }

  initWorld() {
    this.worldCanvas = document.querySelector("canvas.experience");
    this.worldScene = new THREE.Scene();
    this.worldCamera = new Camera(this.worldCanvas, this.worldScene, this);

    // On stocke la position et la cible dans des propriétés
    this.cameraPosition = new THREE.Vector3(10, 0, 5);
    this.cameraTarget = new THREE.Vector3(0, 0, 0);

    // On utilise ces propriétés pour définir l'état initial
    this.worldCamera.setCinematicState(this.cameraPosition, this.cameraTarget);

    this.worldRenderer = new Renderer(
      this.worldCanvas,
      this.worldScene,
      this.worldCamera,
      this
    );

    this.world = new World(this.worldScene, this);

    if (this.debug.active) {
      this.setDebug();
    }
  }

  initTransition() {
    this.transitionCanvas = document.querySelector("canvas.preloader");
    this.transitionScene = new THREE.Scene();
    this.transitionCamera = new Camera(
      this.transitionCanvas,
      this.transitionScene,
      this
    );

    this.transitionRenderer = new Renderer(
      this.transitionCanvas,
      this.transitionScene,
      this.transitionCamera,
      this
    );

    this.transition = new Transition(this.transitionScene, this);
  }

  initEvents() {
    this.sizes.on("resize", () => {
      this.resize();
    });

    this.time.on("tick", () => {
      this.update();
    });
  }

  resize() {
    if(this.worldCamera) this.worldCamera.resize();
    if(this.transitionCamera) this.transitionCamera.resize();
    if(this.transitionRenderer) this.transitionRenderer.resize();
    if(this.worldRenderer) this.worldRenderer.resize();
  }

  update() {
    if (this.worldCamera) this.worldCamera.update();
    if (this.world) this.world.update();
    if (this.worldRenderer) this.worldRenderer.update();
    if (this.transitionRenderer) this.transitionRenderer.update();
  }

  destroy() {
    this.sizes.off("resize");
    this.time.off("tick");

    if (this.world && typeof this.world.destroy === "function") {
      this.world.destroy(); // World s'occupe de Particles.destroy() et Tentacle.destroy()
    }

    if (this.defaultCamera && this.defaultCamera.controls) {
      this.defaultCamera.controls.dispose();
    }

    if (this.worldRenderer) {
      this.worldRenderer.instance.dispose();
    }

    if (this.transitionRenderer) {
      this.transitionRenderer.instance.dispose();
    }

    if (this.debug && this.debug.active && this.debug.ui) {
      this.debug.ui.destroy();
    }
  }

  setDebug() {
    if (this.debug.ui && this.worldCamera) {
      const cameraFolder = this.debug.ui.addFolder("World Camera");

      // Slider pour la position X
      cameraFolder
        .add(this.cameraPosition, "x")
        .min(-20)
        .max(20)
        .step(0.1)
        .name("Position X")
        .onChange(() => {
          this.worldCamera.setCinematicState(
            this.cameraPosition,
            this.cameraTarget
          );
        });

      // Slider pour la position Y
      cameraFolder
        .add(this.cameraPosition, "y")
        .min(-20)
        .max(20)
        .step(0.1)
        .name("Position Y")
        .onChange(() => {
          this.worldCamera.setCinematicState(
            this.cameraPosition,
            this.cameraTarget
          );
        });

      // Slider pour la position Z
      cameraFolder
        .add(this.cameraPosition, "z")
        .min(-20)
        .max(20)
        .step(0.1)
        .name("Position Z")
        .onChange(() => {
          this.worldCamera.setCinematicState(
            this.cameraPosition,
            this.cameraTarget
          );
        });
    }
  }
}
